import React from "react";
import FilterSidebar from "./FilterSidebar";
import RestaurantList from "./RestaurantList";

const RestaurantFeed = () => {
  return (
    <>
      <div className="row restaurant-feed my-5">
        <div className="col-12 col-md-3">
          <FilterSidebar />
        </div>
        <div className="col-12 col-md-9">
          <RestaurantList />
        </div>
      </div>
    </>
  );
};
export default RestaurantFeed;
